import { createSlice } from "@reduxjs/toolkit";
import { getLocationListThunk } from "./sharedThunk";

const sharedSlice = createSlice({
    name:"shared",
    initialState:{
        locationDashboardSharedList : [],
        locationSharedList:[],
        shiftStartTimeList:[],
        shiftEndTimeList:[],
        shiftLengthSharedList:[],
        covidVaccineSharedList:[],
        spokenLanguageSharedList:[],
        distanceSharedList:[],
        statusSharedList:[],
        preferredShiftSharedList:[],
        preferredShiftTimeSharedList:[]
    },
    reducers:{
        updateSharedSlice:(state,{payload:{name,value}}) => {
            state[name] = value;
        }
    },
    extraReducers: builder => {
        builder.addCase(getLocationListThunk.fulfilled, (state,{payload}) => {
            state.locationDashboardSharedList = payload
        })
    }
});
export const {updateSharedSlice} = sharedSlice.actions;
export default sharedSlice.reducer;